import { render, staticRenderFns } from "./GoogleCalendarReminder.vue?vue&type=template&id=239c354c"
import script from "./GoogleCalendarReminder.vue?vue&type=script&lang=ts"
export * from "./GoogleCalendarReminder.vue?vue&type=script&lang=ts"
import style0 from "./GoogleCalendarReminder.vue?vue&type=style&index=0&id=239c354c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('239c354c')) {
      api.createRecord('239c354c', component.options)
    } else {
      api.reload('239c354c', component.options)
    }
    module.hot.accept("./GoogleCalendarReminder.vue?vue&type=template&id=239c354c", function () {
      api.rerender('239c354c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/GoogleCalendarReminder.vue"
export default component.exports